<template>
  <portal to="map">
    <span ref="popover" class="ui-map-popover--wrapper tw:relative">
      <div class="ui-map-popover tw:relative" :class="`ui-map-popover-position--${positioning}`">
        <div class="ui-map-popover--arrow ui-map-popover--arrow__visible"></div>
        <div class="ui-map-popover--arrow"></div>
        <div class="ui-map-popover--content">
          <slot></slot>
        </div>
      </div>
    </span>
  </portal>
</template>

<script>
export default {
  name: 'PopoverMap',
  props: {
    id: {
      type: String,
      required: true,
    },
    position: {
      type: Array,
      required: true,
    },
    positioning: {
      type: String,
      default: 'bottom-center',
    },
  },
  watch: {
    position(nV) {
      this.$root.$emit('setMapOverlayProperty', this.id, 'position', nV);
    },
  },
  beforeDestroy() {
    this.$root.$emit('removeOverlays', { id: this.id });
  },
  mounted() {
    this.$nextTick(() => {
      this.$root.$emit('createMapOverlay', {
        id: this.id,
        selector: this.$refs.popover,
        overlayProps: {
          className: 'tw:pointer-events-none',
          position: this.position,
          positioning: this.positioning,
          autoPan: true,
        },
      });
    });
  },
};
</script>

<style lang="scss" scoped>
$arrowSide: 11px;
$arrowDiagonal: calc((#{$arrowSide} * (2 * (1 / 2))) + 3px);

.ui-map-popover::before {
  content: '';
  top: calc(#{$arrowDiagonal} * -1);
  left: calc(#{$arrowDiagonal} * -1);
  height: calc(100% + calc(#{$arrowDiagonal} * 2));
  width: calc(100% + calc(#{$arrowDiagonal} * 2));
  background-color: transparent;
  position: absolute;
  z-index: -1;
}

.ui-map-popover--arrow {
  position: absolute;
  width: $arrowSide;
  height: $arrowSide;
  background: #fff;
  transform: rotate(45deg);
}

/** 
  Positioning styles. Add more if required. Currently available:
  - bottom-center
*/
.ui-map-popover-position--bottom-center .ui-map-popover--arrow {
  bottom: calc(((#{$arrowSide} * -1) / 2) + 2px);
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}
.ui-map-popover-position--bottom-center {
  transform: translateY(calc(((#{$arrowSide} * -1) / 2) - 2px));
}
</style>

<style scoped>
@reference '@/tailwind.css';

.ui-map-popover--content {
  @apply tw:bg-white! tw:border! tw:border-gray-200! tw:shadow-md! tw:rounded-base! tw:p-3.5! tw:cursor-default! tw:pointer-events-auto!;
}

.ui-map-popover--arrow__visible {
  @apply tw:shadow-md! tw:outline! tw:outline-gray-200! tw:-z-1;
}
</style>
